import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  title: {value: "", matchMode: "contains" },
  isAnonymous: {value: "", matchMode: "equals" },
  active: {value: "", matchMode: "equals" },
  createdAt: {value: "", matchMode: "equals" }
};

export const useFilterFormsInstanceStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));